import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  input,
  output
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';

import {
  ButtonComponent,
  BlockDirective,
  HoldingResponse,
  IfFeatureService,
  ToastMessageService,
  ModalCloseDirective,
  ModalPanelComponent,
  NotificationComponent,
  SymbolLogoComponent,
  TickerSymbolComponent,
  TickerSymbolTableContainerComponent,
  DataAnalyticsService,
  MediaQueryService,
  Breakpoint,
  BreakpointState,
  ModalHeaderComponent,
  ModalHeaderTitleComponent
} from '@tdwb/core';
import { FplOnLoanHolding } from '@tdwb/webbroker/core';
import { FplRestService } from './../services/fpl-rest.service';

@Component({
  selector: 'td-wb-fpl-recall-security',
  templateUrl: 'fpl-recall-security.component.html',
  styleUrls: ['fpl-recall-security.component.scss'],
  imports: [
    TranslateDirective,
    ModalPanelComponent,
    SymbolLogoComponent,
    NotificationComponent,
    ButtonComponent,
    ModalCloseDirective,
    BlockDirective,
    TickerSymbolComponent,
    TickerSymbolTableContainerComponent,
    ModalHeaderComponent,
    ModalHeaderTitleComponent
  ]
})
export class FplRecallSecurityComponent {
  private readonly fplRestService = inject(FplRestService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly ifFeatureService = inject(IfFeatureService);
  private readonly dataAnalyticsService = inject(DataAnalyticsService);
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly destroyRef = inject(DestroyRef);

  readonly holding = input.required<HoldingResponse | FplOnLoanHolding>();
  readonly accountId = input.required<string>();
  readonly numberOfShares = input.required<number>();
  readonly recallSucessful = output<void>();

  showLogo: boolean = false;
  disableRecall: boolean = false;
  isMobile: boolean = false;

  constructor() {
    this.mediaQueryService.observe(Breakpoint.SM)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((breakpointState: BreakpointState): void => {
        this.isMobile = breakpointState.isBreakpointMatch(Breakpoint.SM);
        this.changeDetectorRef.markForCheck();
      });
    this.showLogo = this.ifFeatureService.getFeatureFlag('wbSymbolLogoOnHoldingsEnabled');
  }

  cancelSecurityRecall(): void {
    this.dataAnalyticsService.emitLinkClickEvent('stocklending:recall:no');
  }

  handleSecurityRecall(): void {
    this.disableRecall = true;
    this.dataAnalyticsService.emitLinkClickEvent('stocklending:recall:yes');
    this.fplRestService.createRestrictions({
      accountId: this.accountId(),
      restrictionType: 'SECURITY',
      securities: [this.holding().cusip],
      recall: true
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: boolean): void => {
          this.disableRecall = false;
          if (response) {
            const holding = this.holding();
            if (holding.symbol?.tickerSymbol) {
              this.toastMessageService.setToast('tdWb.fpl.recall.TOAST_MESSAGE_WITH_SYMBOL', { numberOfShares : this.numberOfShares(), symbol: holding.symbol.tickerSymbol });
            } else {
              this.toastMessageService.setToast('tdWb.fpl.recall.TOAST_MESSAGE_WITHOUT_SYMBOL', { numberOfShares : this.numberOfShares() });
            }
            this.recallSucessful.emit();
          }
          this.changeDetectorRef.markForCheck();
        },
        error: (): void => {
          this.disableRecall = false;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

}
